/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import {
  FaChevronDown,
  FaChevronUp,
  FaFolderOpen,
  FaHistory,
  FaHome,
  FaKey,
  FaPlus,
} from 'react-icons/fa';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { SearchInput } from '../search/search.Input';
import axios from 'axios';
import { BtnSimple } from '../form/btn.Simple';
import { createNewItem } from '../../services/item';
import { isGlobalAdmin } from '../../utils/roles';
import { saveMany } from '../../store/items';
import { ThemeChange } from '../theme/theme.Change';
import { canAccessItem } from '../../utils/item';
import {
  getStoredAuthUser,
  isUniverseAdmin,
  isMjForItem,
} from '../../utils/auth';
import { NavigationDisplayItems } from './navigation.displayItems';
import { Link } from 'react-router-dom';
import { NavigationView } from './navigation.View';
import { setListCampaignsId, setOpenModales } from '../../store/global';
import { NavigationManagePassword } from './navigation.Passwords';
import { NavigationFolder } from './navigation.Folder';
import { LinkNew } from '../link/link.New';

export const NavigationGlobal = props => {
  const { itemId, hideBottomNav, style } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const universe = useSelector(state => state.items[item.universe]);
  const navigation = useSelector(state => state.global.navigation);
  const historyItems = useSelector(state => {
    const ids = state.global.history || [];
    const result = [];
    for (const id of ids) {
      if (id !== itemId) {
        const historyItem = state.items[id];
        if (historyItem) {
          result.push(historyItem);
        }
      }
    }
    return result;
  }, shallowEqual);

  const dispatch = useDispatch();

  const [collapsedParentItems, setCollapsedParentItems] = useState(false);
  const [listCampaigns, setListCampaigns] = useState([]);
  const [searchIn, setSearchIn] = useState({
    type: undefined,
    universe: true,
    world: true,
    campaign: false,
  });
  const lastUniverseIdRef = useRef(null);
  const hasMjForItem = isMjForItem(item, items);
  const authUser = getStoredAuthUser();
  const authUserId = authUser?._id;
  const universeForAuth = item?.type === 'universe' ? item : universe;
  const isAdminOfUniverse = isUniverseAdmin(universeForAuth, authUserId);
  const canMj = isGlobalAdmin() || hasMjForItem || isAdminOfUniverse;
  const goBackTo =
    item.type === 'world' && canMj
      ? item.universe
      : item.type === 'campaign' &&
          canMj &&
          item.world !== process.env.REACT_APP_NONE_VISITOR
        ? item.world
        : item.type === 'campaign' &&
            canMj &&
            item.world === process.env.REACT_APP_NONE_VISITOR
          ? item.universe
          : item.campaign !== process.env.REACT_APP_NONE_VISITOR
            ? item.campaign
            : null;

  const getAllCampaign = async universeId => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/items/allcampaigns/${universeId}`,
    );
    if (res?.data) {
      //order res alphabetically
      res.data.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      dispatch(saveMany({ items: res.data, log: 'from getAllCampaign' }));
      setListCampaigns(res.data);
    }
  };

  useEffect(() => {
    if (!navigation?.open) {
      return;
    }
    if (!canMj) {
      setSearchIn(prev => {
        if (
          prev.type === undefined &&
          prev.universe === true &&
          prev.world === true &&
          prev.campaign === false
        ) {
          return prev;
        }
        return {
          type: undefined,
          universe: true,
          world: true,
          campaign: false,
        };
      });
    }

    const universeId =
      universe?._id ?? (item?.type === 'universe' ? item?._id : null);
    if (universeId && lastUniverseIdRef.current !== universeId) {
      lastUniverseIdRef.current = universeId;
      getAllCampaign(universeId);
    }
  }, [universe?._id, item?._id, item?.type, canMj, navigation?.open]);

  useEffect(() => {
    dispatch(
      setListCampaignsId(
        listCampaigns.map(c => {
          const campaignUniverse = c?.universe ? items[c.universe] : null;
          const canAccess = canAccessItem(
            c,
            c,
            null,
            campaignUniverse || universeForAuth,
          );
          return (canAccess || canMj) && c._id && c._id;
        }),
      ),
    );
  }, [listCampaigns, isAdminOfUniverse, items, universeForAuth, hasMjForItem]);

  return (
    <div
      className='h-full bg-main transition-all flex flex-col overflow-auto border-l border-main-d  border-opacity-20'
      style={{
        width: navigation.size,
        marginRight: navigation.open ? 0 : -navigation.size,
        position: navigation.open ? 'absolute' : 'unset',
        right: navigation.open ? 0 : -navigation.size,
        zIndex: 1201,
        top: 0,
        ...style,
      }}
    >
      <div className='border-b border-primary border-opacity-50 '>
        <SearchInput
          className='m-05'
          itemId={itemId}
          searchIn={searchIn}
          enableCampaignFilter={true}
        />
      </div>
      <div>
        <div
          className={`${
            collapsedParentItems === true ? 'sticky top-0 ' : ''
          } backdrop-blur-md bg-main bg-opacity-50 flex items-center gap-1 transition cursor-pointer font-condensed font-bold text-lg px-05 mt-1`}
          onClick={() => setCollapsedParentItems(!collapsedParentItems)}
        >
          {collapsedParentItems ? <FaChevronUp /> : <FaChevronDown />}
          {item?.label}
        </div>

        {collapsedParentItems && (
          <div className=''>
            <NavigationView
              parentId={item?._id}
              viewId={item?.view}
            />
            <BtnSimple
              className='flex gap-1 items-center mt-1 mx-1 bg-main'
              onClick={() =>
                dispatch(setOpenModales({ id: 'addLink' + itemId, open: true }))
              }
            >
              <FaPlus /> Ajouter un {item.type ? 'item' : 'lien'}
            </BtnSimple>
          </div>
        )}
      </div>

      {listCampaigns.map(campaignInWorld => {
        const liveCampaign = items?.[campaignInWorld?._id];
        if (!liveCampaign) {
          return null;
        }
        const canAccess =
          canAccessItem(
            liveCampaign,
            liveCampaign,
            null,
            liveCampaign?.universe ? items[liveCampaign.universe] : null,
          ) || canMj;
        if (!canAccess || liveCampaign._id === itemId) {
          return null;
        }
        return (
          <NavigationFolder
            key={liveCampaign._id}
            folder={liveCampaign}
            isAdminOfUniverse={isAdminOfUniverse}
          />
        );
      })}
      <div>
        {canMj && (
          <BtnSimple
            className='flex gap-1 items-center mt-1 mx-1'
            onClick={() =>
              createNewItem(
                {
                  label: 'nouveau dossier',
                  callback: item => setListCampaigns(prev => [...prev, item]),
                  type: 'campaign',
                },
                item,
              )
            }
          >
            <FaPlus /> Créer un dossier
          </BtnSimple>
        )}
      </div>

      <div
        className='sticky top-0 backdrop-blur-md bg-main bg-opacity-50 flex items-center gap-1 font-condensed font-bold text-lg px-05 mt-1'
        // onClick={() => setCollapsedParentItems(!collapsedParentItems)}
      >
        <FaHistory />
        Historique
      </div>
      <div className='flex-1'>
        {historyItems?.map(
          historyItem =>
            historyItem?._id && (
              <NavigationDisplayItems
                key={historyItem._id}
                displayItem={historyItem}
                big={true}
              />
            ),
        )}
      </div>
      {hideBottomNav !== true && (
        <div className='w-full flex justify-evenly border-t border-main-d py-05 sticky bottom-0 bg-main gap-1'>
          <Link to='/'>
            <FaHome className='transition hover:opacity-50 cursor-pointer' />
          </Link>
          {canMj && goBackTo && (
            <Link to={`../../item/${goBackTo}`}>
              <FaFolderOpen className='transition hover:opacity-50 cursor-pointer' />
            </Link>
          )}
          <ThemeChange />
          <NavigationManagePassword />
          <div
            className='transition hover:opacity-50 cursor-pointer'
            onClick={() =>
              dispatch(setOpenModales({ id: 'managePassword', open: true }))
            }
          >
            <FaKey />
          </div>
        </div>
      )}
      <LinkNew
        mode={item.type ? 'folder' : null}
        itemId={item._id}
      />
    </div>
  );
};
